(() => {
 // Draft products share a preview path. Load the chosen preview in full so
 // the theme's product navigation cannot reuse the preceding product page.
 document.addEventListener('click', event => {
  if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const link = event.target.closest('[data-catalog-card] a[href]');
  if (!link || new URL(link.href).pathname !== '/products_preview') return;
  event.preventDefault();
  event.stopImmediatePropagation();
  location.assign(link.href);
 }, true);
 const audiences = ['women', 'men', 'youth', 'kids'];
 const setContext = (card, audience) => {
  card.querySelectorAll('a[href]').forEach(link => {
   const url = new URL(link.getAttribute('href'), location.origin);
   if (audience && audience !== 'all') url.searchParams.set('audience', audience);
   else url.searchParams.delete('audience');
   if (card.dataset.kind === 'art') { url.searchParams.set('department', 'designs'); url.searchParams.delete('audience'); }
   else url.searchParams.delete('department');
   link.setAttribute('href', url.pathname + url.search + url.hash);
  });
 };
 const setupCatalog = root => {
  if (root.dataset.bound) return;
  root.dataset.bound = 'true';
  const form = root.querySelector('[data-catalog-controls]');
  const grid = root.querySelector('[data-catalog-grid]');
  const cards = [...grid.querySelectorAll('[data-catalog-card]')];
  const panel = root.querySelector('[data-filter-menu]');
  const labels = JSON.parse(root.dataset.labels);
  const params = new URLSearchParams(location.search);
  const department = root.dataset.department === 'designs' ? 'designs' : 'apparel';
  for (const key of ['audience', 'design', 'type', 'sort']) {
   const select = form.elements[key];
   const value = params.get(key) || root.dataset[key] || (key === 'sort' ? 'featured' : 'all');
   if ([...select.options].some(option => option.value === value)) select.value = value;
  }
  if (department === 'designs') { form.elements.audience.value = 'all'; form.elements.type.value = 'all'; }
  const close = (focus = false) => {
   panel.open = false;
   if (focus) panel.querySelector('summary').focus();
  };
  const apply = (update = false) => {
   const audience = department === 'designs' ? 'all' : form.elements.audience.value;
   const design = form.elements.design.value;
   const type = form.elements.type.value;
   const sort = form.elements.sort.value;
   const isDesigns = department === 'designs';
   const matches = cards.filter(card => {
    const match = ((card.dataset.kind === 'art') === isDesigns) &&
     (audience === 'all' || card.dataset.audience.split(' ').includes(audience)) &&
     (design === 'all' || card.dataset.design.split(' ').includes(design)) &&
     (type === 'all' || type === card.dataset.kind || type === card.dataset.style);
    card.hidden = !match;
    if (match) setContext(card, audience);
    return match;
   });
   const compare = (a, b, key) => a.dataset[key].localeCompare(b.dataset[key]);
   matches.sort((a, b) => sort === 'name-asc' ? compare(a,b,'name') : sort === 'name-desc' ? compare(b,a,'name') :
    sort === 'price-asc' ? +a.dataset.price - +b.dataset.price : sort === 'price-desc' ? +b.dataset.price - +a.dataset.price :
    sort === 'type' ? compare(b,a,'kind') || compare(a,b,'name') : sort === 'design' ? compare(a,b,'design') || compare(a,b,'name') : +a.dataset.order - +b.dataset.order
   ).forEach(card => grid.append(card));
   root.querySelector('[data-result-count]').textContent = matches.length + ' ' + labels[matches.length === 1 ? 'one' : 'many'];
   root.querySelector('[data-empty]').hidden = matches.length > 0;
   const title = isDesigns ? [labels.designs] : [];
   if (audience !== 'all') title.push(labels[audience]);
   if (design !== 'all' && !(audience === 'youth' && design === 'senior')) title.push(form.elements.design.selectedOptions[0].textContent);
   if (type !== 'all') title.push(form.elements.type.selectedOptions[0].textContent);
   root.querySelector('[data-catalog-heading]').textContent = title.join(' · ') || labels.all;
   root.querySelectorAll('[data-audience-link]').forEach(link => {
    if (!isDesigns && link.dataset.audienceLink === audience) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
   });
   root.querySelector('[data-designs-link]')?.toggleAttribute('aria-current', isDesigns);
   const designsLink = root.querySelector('[data-designs-link]');
   if (isDesigns && designsLink) designsLink.setAttribute('aria-current', 'page');
   root.querySelectorAll('[data-design-category]').forEach(link => {
    const category = link.dataset.designCategory;
    if (category === design) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
    const count = cards.filter(card => card.dataset.kind === 'art' && (category === 'all' || card.dataset.design.split(' ').includes(category))).length;
    const badge = link.querySelector('[data-category-count]');
    if (badge) badge.textContent = count;
   });
   const note = root.querySelector('[data-designs-note]');
   if (note) note.hidden = !isDesigns;
   const active = [audience, design, type].filter(value => value !== 'all').length + (sort !== 'featured' ? 1 : 0);
   const badge = root.querySelector('[data-filter-count]');
   badge.textContent = active;
   badge.hidden = active === 0;
   if (update) {
    const url = new URL(location.href);
    for (const [key, value] of Object.entries({audience, design, type, sort})) {
     if (value === 'all' || value === 'featured') url.searchParams.delete(key);
     else url.searchParams.set(key, value);
    }
    if (isDesigns) url.searchParams.set('department', 'designs');
    else url.searchParams.delete('department');
    history.replaceState(null, '', url);
   }
  };
  root.querySelectorAll('[data-design-category]').forEach(link => link.addEventListener('click', event => {
   if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
   event.preventDefault();
   form.elements.design.value = link.dataset.designCategory;
   form.elements.type.value = 'all';
   form.elements.audience.value = 'all';
   apply(true);
  }));
  form.addEventListener('submit', event => { event.preventDefault(); apply(true); close(true); });
  form.addEventListener('change', event => { apply(true); if (event.target.name === 'sort') close(true); });
  form.querySelector('[data-clear]').addEventListener('click', () => {
   for (const key of ['audience', 'design', 'type']) form.elements[key].value = 'all';
   form.elements.sort.value = 'featured';
   apply(true); close(true);
  });
  panel.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); close(true); } });
  document.addEventListener('click', event => { if (!panel.contains(event.target)) close(); });
  apply();
 };
 const setupSuggestions = root => {
  if (root.dataset.bound) return;
  root.dataset.bound = 'true';
  const source = root.querySelector('template');
  const cards = [...source.content.querySelectorAll('[data-catalog-card]')];
  const current = cards.find(card => card.dataset.productId === root.dataset.productId);
  if (!current) { root.dispatchEvent(new CustomEvent('droid:recommendations-fallback', { bubbles: true })); return; }
  const requested = new URLSearchParams(location.search).get('audience');
  const currentAudiences = current.dataset.audience.split(' ');
  const audience = audiences.includes(requested) && currentAudiences.includes(requested) ? requested : currentAudiences[0];
  const isDesigns = current.dataset.kind === 'art';
  const audienceCards = cards.filter(card => card !== current && (isDesigns ? card.dataset.kind === 'art' : card.dataset.audience.split(' ').includes(audience)));
  const candidates = audienceCards.filter(card => isDesigns ? card.dataset.kind === 'art' : current.dataset.kind === 'bottoms' ? card.dataset.kind === 'bottoms' : card.dataset.kind !== 'art' && card.dataset.kind !== 'bottoms');
  const paired = current.dataset.pair ? audienceCards.filter(card => card.dataset.pair === current.dataset.pair) : [];
  const clone = card => { const copy = card.cloneNode(true); setContext(copy, audience); return copy; };
  if (paired.length) {
   const intro = root.querySelector('[data-matching-intro]');
   const grid = root.querySelector('[data-pair-grid]');
   paired.sort((a,b) => (a.dataset.kind === 'bottoms' ? -1 : 1) - (b.dataset.kind === 'bottoms' ? -1 : 1));
   paired.forEach(card => grid.append(clone(card)));
   intro.hidden = false;
  }
  const designs = current.dataset.design.split(' ');
  const score = card => card.dataset.design.split(' ').filter(design => designs.includes(design)).length;
  const recommendations = candidates.filter(card => !paired.includes(card));
  recommendations.sort((a,b) => score(b) - score(a) || +a.dataset.order - +b.dataset.order);
  recommendations.slice(0,12).forEach(card => root.querySelector('[data-suggestion-grid]').append(clone(card)));
  const browse = root.querySelector('[data-browse-section]');
  browse.href = isDesigns ? '/collections/droid-art-dtf-designs' : browse.getAttribute('href') + '?audience=' + audience + (current.dataset.kind === 'bottoms' ? '&type=bottoms' : '');
  browse.textContent = isDesigns ? browse.dataset.designsLabel : current.dataset.kind === 'bottoms' ? browse.dataset.bottomsLabel : browse.dataset.apparelLabel;
  source.remove();
  root.dispatchEvent(new CustomEvent('droid:rail-ready', { bubbles: true }));
 };
 const init = () => {
  document.querySelectorAll('[data-catalog]').forEach(setupCatalog);
  document.querySelectorAll('[data-suggestions]').forEach(setupSuggestions);
  document.querySelectorAll('[data-native-sort]').forEach(panel => {
   if (panel.dataset.bound) return;
   panel.dataset.bound = 'true';
   panel.querySelector('select').addEventListener('change', event => { panel.open = false; event.target.form.requestSubmit(); });
  });
 };
 init();
 document.addEventListener('shopify:section:load', init);
})();

